import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { init } from '@telegram-apps/sdk';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { RestClientProvider } from './api/RestClientProvider';
import { AppLayout } from './app/AppLayout';
import './index.css';
import NavigationPanel from './shared/components/NavigationPanel';
import { GlobalNotificationToast } from './shared/components/NotificationToast';
import { getTelegramInitData, isTelegramMiniApp } from './utils/telegram';

function RootApp() {
	const [navOpen, setNavOpen] = React.useState<boolean>(true);

	return (
		<BrowserRouter>
			<AppLayout>
				<GlobalNotificationToast>
					<NavigationPanel open={navOpen} onOpenChange={setNavOpen} />
					<App />
				</GlobalNotificationToast>
			</AppLayout>
		</BrowserRouter>
	);
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

const client = new QueryClient();
const baseUrl = process.env.REACT_APP_BASE_URL || '/api';



const telegramRuntime = isTelegramMiniApp();
const initData = telegramRuntime && process.env.NODE_ENV !== 'development'
	? getTelegramInitData()
	: '';
console.log(`initial data retrieved: ${initData}`)

if (telegramRuntime && process.env.NODE_ENV !== 'development') {
	init();
}

root.render(
	<React.StrictMode>
		<QueryClientProvider client={client}>
			<RestClientProvider baseUrl={baseUrl} initData={initData}>
				<RootApp />
			</RestClientProvider>
		</QueryClientProvider>
	</React.StrictMode>
);
